import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Shares open/closed state between <Sidebar /> and <SidebarToggle />
 * so the toggle button can live anywhere on the page (page header,
 * top bar, wherever) without prop-drilling.
 *
 * Wrap any page that has a sidebar in <SidebarProvider>:
 *
 *   <SidebarProvider>
 *     <Sidebar />
 *     <main>
 *       <SidebarToggle />
 *       ...page content...
 *     </main>
 *   </SidebarProvider>
 */

const SidebarContext = createContext(null);

export function SidebarProvider({ children, side }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <SidebarContext.Provider value={{ isOpen, toggle, close, side }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return ctx;
}
